import { render, staticRenderFns } from "./updateRelayMultiple.vue?vue&type=template&id=0c99a112&"
import script from "./updateRelayMultiple.vue?vue&type=script&lang=js&"
export * from "./updateRelayMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports